import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class OrderHistroy extends Mixins(CommonView) {

    public planOrderHistory: SBAPI.PlanOrderHistory[] = [];
    public error: string = "";

    public async created() {
        if (await this.isLoginRedirect(true)) return;

        this.getPlanOrderHistoryList();
    }

    public async getPlanOrderHistoryList() {
        let response = await SBAPI.PlanOrderHistoryController.getPlanOrderHistoryListUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return
        };
        this.planOrderHistory = response.data;
    }

}
